import { Button } from '~m/designSystem'
import SearchIcon from '@mui/icons-material/Search'
import React from 'react'
import { Kbd } from '~m/designSystem/components/Kbd'
import { useGlobalDialog } from '~m/AppUi/context'

export function QuickSearchButton() {
  const { showGlobalDialog } = useGlobalDialog()
  return (
    <Button
      variant="outlined"
      startIcon={<SearchIcon />}
      endIcon={<Kbd mod>k</Kbd>}
      onClick={() => {
        showGlobalDialog('search')
      }}
    >
      Search
    </Button>
  )
}
